module.exports = __webpack_public_path__ + "img/info-abonnement.bd708cb6.svg";